import React, { Component } from "react";

class Footer extends Component {

  render() {
    return <footer className="footer">
      <div className="content">
        <h2 className="footer_text">
          Todos los derechos reservados. © Grupo Davivienda {new Date().getFullYear()}.
        </h2>
      </div>
    </footer>
  }

}

export default Footer;
